theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelector(".offcanvas__menu"),
        body = document.querySelector("body");

      if (!offcanvasOpen || !offcanvasClose || !offcanvasHeader || !offcanvasMenu) return;
      if (offcanvasHeader.dataset.keyboardReady === 'true') return;
      offcanvasHeader.dataset.keyboardReady = 'true';
      const triggers = document.querySelectorAll('.header__actions_btn--menu');
      let wasOpen = false;
      let returnTarget = offcanvasOpen;
      const isOpen = () => offcanvasHeader.classList.contains('open') || offcanvasHeader.classList.contains('active');
      const focusable = () => Array.from(offcanvasHeader.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter(el => !el.disabled && el.tabIndex >= 0 && !el.closest('[inert], [aria-hidden="true"]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const closeDrawer = () => {
        offcanvasHeader.classList.remove('open', 'active');
        body.style.overflowY = '';
      };
      const syncDrawer = () => {
        const opened = isOpen();
        if (opened === wasOpen) return;
        if (opened) returnTarget = document.activeElement;
        offcanvasHeader.inert = !opened;
        offcanvasHeader.setAttribute('aria-hidden', String(!opened));
        triggers.forEach(el => {
          el.setAttribute('aria-controls', offcanvasHeader.id);
          el.setAttribute('aria-expanded', String(opened));
        });
        wasOpen = opened;
        if (opened) offcanvasClose.focus({ preventScroll: true });
        else if (returnTarget && returnTarget.isConnected) returnTarget.focus({ preventScroll: true });
      };
      new MutationObserver(syncDrawer).observe(offcanvasHeader, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('keydown', event => {
        if (!isOpen()) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDrawer();
        } else if (event.key === 'Tab') {
          const items = focusable();
          const first = items[0];
          const last = items[items.length - 1];
          if (!first) {
            event.preventDefault();
            offcanvasHeader.focus();
          } else if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
            event.preventDefault();
            first.focus();
          }
        }
      });
      document.addEventListener('focusin', event => {
        if (isOpen() && !offcanvasHeader.contains(event.target)) offcanvasClose.focus({ preventScroll: true });
      });
      triggers.forEach(el => {
        if (el.tagName !== 'BUTTON') el.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            el.click();
          }
        });
      });

      /* Add a Button For SubMenu Toggle */
      offcanvasMenu
        .querySelectorAll(".offcanvas__sub_menu")
        .forEach(function (ul) {
          const subMenuToggle = document.createElement("button");
          subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
          subMenuToggle.setAttribute("aria-label", "menu collapse");
          ul.parentNode.appendChild(subMenuToggle);
        });

      /* Open/Close Menu On Click Toggle Button */
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.add("open");
        body.style.overflowY = "hidden";
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.remove("open");
        body.style.overflowY = null;
      });
      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu
        .querySelectorAll(".offcanvas__sub_menu_toggle")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.parentElement;
            if (parent.classList.contains("active")) {
              this.classList.remove("active");
              parent.classList.remove("active");
              parent
                .querySelectorAll(".offcanvas__sub_menu")
                .forEach(function (subMenu) {
                  subMenu.parentElement.classList.remove("active");
                  subMenu.nextElementSibling.classList.remove("active");
                  slideUp(subMenu);
                });
            } else {
              this.classList.add("active");
              parent.classList.add("active");
              slideDown(this.previousElementSibling);
              getSiblings(parent).forEach(function (item) {
                item.classList.remove("active");
                item
                  .querySelectorAll(".offcanvas__sub_menu")
                  .forEach(function (subMenu) {
                    subMenu.parentElement.classList.remove("active");
                    subMenu.nextElementSibling.classList.remove("active");
                    slideUp(subMenu);
                  });
              });
            }
          });
        });

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            offcanvasHeader.classList.remove("open");
            body.style.overflowY = null;
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          offcanvasHeader.classList.remove("open");
          body.style.overflowY = null;
        }
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();
